/* eslint-disable max-lines-per-function */
import { E2NTableCell } from '../../../../components/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faCheck, faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@/components/ui/button';
import {
  useDienstplansuebernahmeIgnorieren,
  useDienstplanuebernahmeUebernehmen,
} from '../../hooks/useDienstplanuebernahme';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useTranslation } from 'react-i18next';
import { DienstplanuebernahmeTableRow } from './dienstplanuebnahmeTable';

export const DienstplanuebernahmeEdit = function EditCell({
  dienstplanuebernahme,
  switchLoadingState,
}: {
  dienstplanuebernahme: DienstplanuebernahmeTableRow;
  switchLoadingState: (state: string) => void;
}) {
  const [ignorieren] = useDienstplansuebernahmeIgnorieren();
  const [uebernehmen] = useDienstplanuebernahmeUebernehmen();
  const { t } = useTranslation();

  return (
    <E2NTableCell className="rounded-r-lg w-40 p-4">
      <div className="flex gap-1">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <Button
                disabled={dienstplanuebernahme.loading}
                onClick={() => {
                  switchLoadingState(dienstplanuebernahme.id);
                  uebernehmen([dienstplanuebernahme]).finally(() => {
                    switchLoadingState(dienstplanuebernahme.id);
                  });
                }}
                className="bg-primary-blue-B100 hover:bg-primary-blue-B500  size-7 transition-colors group">
                {dienstplanuebernahme.loading && (
                  <FontAwesomeIcon
                    className="text-primary-blue-B600 "
                    icon={faSpinner}
                    spin
                  />
                )}
                {!dienstplanuebernahme.loading && (
                  <FontAwesomeIcon
                    className="text-primary-blue-B600 group-hover:text-white"
                    icon={faCheck}
                  />
                )}
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              {t(
                'domain.arbeitszeiten.dienstplanuebernahme.buttons.uebernehmen_one',
              )}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <Button
                disabled={dienstplanuebernahme.loading}
                onClick={() => {
                  switchLoadingState(dienstplanuebernahme.id);
                  ignorieren([dienstplanuebernahme]).finally(() => {
                    switchLoadingState(dienstplanuebernahme.id);
                  });
                }}
                className="bg-primary-red-R200  hover:bg-primary-red-R500 size-7 group">
                {dienstplanuebernahme.loading && (
                  <FontAwesomeIcon
                    icon={faSpinner}
                    spin
                    className="text-primary-red-R500"
                  />
                )}
                {!dienstplanuebernahme.loading && (
                  <FontAwesomeIcon
                    icon={faBan}
                    className=" group-hover:text-white text-primary-red-R500"
                  />
                )}
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              {t(
                'domain.arbeitszeiten.dienstplanuebernahme.buttons.ignorieren_one',
              )}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </E2NTableCell>
  );
};
